// This is example of menu item without group for horizontal layout. There will be no children.

// third-party
import { FormattedMessage } from 'react-intl';
import { Tooltip } from '@mui/material';

// assets
import colors from '../../assets/scss/_themes-vars.module.scss';

// type
import { useUnreadCount } from '../../hooks/useUnreadCount';
import { useCurrentUser } from '../../hooks/useUser.hooks';

// ==============================|| MENU ITEMS - SAMPLE PAGE ||============================== //

const MessagesTitle = () => {
    const userState = useCurrentUser();
    const unreadData = useUnreadCount(userState.ready ? userState.user?.id : undefined);
    const unreadCount = unreadData?.total ?? 0;

    // Tooltip with regional breakdown of unread conversations
    const tooltipContent = () => {
        if (!unreadData?.breakdown || unreadData.breakdown.length === 0) {
            return 'No unread conversations';
        }

        // Filter out regions with 0 unread count for cleanliness
        const regionsWithUnread = unreadData.breakdown.filter(region => region.unread_count > 0);
        
        if (regionsWithUnread.length === 0) {
            return 'No unread conversations';
        }

        return (
            <div style={{ padding: '4px' }}>
                <div style={{ fontWeight: 'bold', marginBottom: '8px' }}>Unread Conversations by Region:</div>
                {regionsWithUnread.map((region, index) => (
                    <div key={region.region_id} style={{ marginBottom: index < regionsWithUnread.length - 1 ? '4px' : '0' }}>
                        {region.region_name}: {region.unread_count}
                    </div>
                ))}
            </div>
        );
    };

    return (
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <FormattedMessage id="Messages" />
            {unreadCount > 0 && (
                <Tooltip title={tooltipContent()} arrow placement="right">
                    <span style={{
                        backgroundColor: colors.secondaryMain,
                        color: colors.primaryLight,
                        borderRadius: '50%',
                        padding: '2px 6px',
                        fontSize: '12px',
                        fontWeight: 'bold',
                        minWidth: '20px',
                        cursor: 'pointer',
                    }}>
                        {unreadCount}
                    </span>
                </Tooltip>
            )}
        </div>
    );
};

export default MessagesTitle;
